import React from "react";
import { Link } from "react-router-dom";
import { Clock, MapPin, BadgeCheck } from "lucide-react";
import { useT } from "../lib/i18n";

const AVAIL_STYLES = {
  AVAILABLE: "bg-[#10B981]/10 text-[#10B981]",
  LIMITED: "bg-[#F59E0B]/10 text-[#F59E0B]",
  UNAVAILABLE: "bg-slate-100 text-[#94A3B8]",
};

export const ExpertAvatar = ({ expert, size = "w-12 h-12" }) =>
  expert.photo_url ? (
    <img src={expert.photo_url} alt={expert.first_name} className={`${size} rounded-xl object-cover`} />
  ) : (
    <div className={`${size} rounded-xl bg-[#0B1B3D] grid place-items-center text-white font-display font-black`}>
      {(expert.first_name || "?")[0]}{(expert.last_name || "")[0]}
    </div>
  );

export const ExpertCard = ({ expert, labels = {} }) => {
  const { t } = useT();
  return (
    <div data-testid={`expert-card-${expert.slug}`} className="bg-white border border-slate-200 rounded-xl p-5 flex flex-col gap-3 hover:border-[#0EA5E9] transition-colors">
      <div className="flex items-start gap-3">
        <ExpertAvatar expert={expert} />
        <div className="min-w-0">
          <p className="font-display font-extrabold text-[#0B1B3D] flex items-center gap-1.5">
            {expert.first_name} {expert.last_name}
            <BadgeCheck className="w-4 h-4 text-[#0EA5E9] shrink-0" title={t("Approved by Konzenzo")} />
          </p>
          <p className="text-sm text-[#475569] line-clamp-2">{expert.headline}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {(expert.primary_expertise || []).map((e) => (
          <span key={e} className="px-2 py-0.5 rounded-full bg-[#0EA5E9]/10 text-[#0EA5E9] text-xs font-bold font-mono-kz">{labels[e] || e}</span>
        ))}
      </div>
      <div className="flex items-center gap-3 text-xs text-[#94A3B8] font-mono-kz">
        <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {expert.country}</span>
        <span>{expert.years_experience}+ {t("yrs")}</span>
        <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {expert.turnaround}</span>
        <span className={`px-2 py-0.5 rounded-full font-bold ${AVAIL_STYLES[expert.availability] || ""}`}>{t(expert.availability)}</span>
      </div>
      <div className="flex items-center justify-between mt-auto pt-2 border-t border-slate-100">
        <p className="font-display font-black text-[#0B1B3D]">€{expert.service?.base_price_eur} <span className="text-xs font-normal text-[#94A3B8]">/ {t("review")}</span></p>
        <Link data-testid={`view-expert-${expert.slug}`} to={`/experts/${expert.slug}`} className="text-sm font-bold text-[#0EA5E9] hover:text-[#0B1B3D]">{t("View Profile")} →</Link>
      </div>
    </div>
  );
};
